import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const NavBar = ({ isAdmin }) => {
  const { t } = useTranslation();
  const [menuOpen, setMenuOpen] = useState(false);

  const handleMenuToggle = () => setMenuOpen((open) => !open);
  const handleMenuClose = () => setMenuOpen(false);

  return (
    <nav className="bg-white shadow-sm fixed w-full z-10 top-0 left-0 border-b border-blue-100">
      <div className="container mx-auto flex items-center justify-between py-3 px-4">
        <Link to="/" className="text-2xl font-extrabold text-blue-700 tracking-wide" onClick={handleMenuClose}>Joy Hostel</Link>
        {/* 汉堡按钮，仅在小屏显示 */}
        <button
          className="md:hidden flex flex-col justify-center items-center w-10 h-10 focus:outline-none"
          onClick={handleMenuToggle}
          aria-label="Toggle menu"
        >
          <span className={`block w-6 h-0.5 bg-blue-700 mb-1 transition-transform ${menuOpen ? 'rotate-45 translate-y-2' : ''}`}></span>
          <span className={`block w-6 h-0.5 bg-blue-700 mb-1 transition-opacity ${menuOpen ? 'opacity-0' : ''}`}></span>
          <span className={`block w-6 h-0.5 bg-blue-700 transition-transform ${menuOpen ? '-rotate-45 -translate-y-2' : ''}`}></span>
        </button>
        {/* 菜单项：桌面端横向，移动端抽屉/下拉 */}
        <div className="hidden md:flex space-x-6">
          <Link to="/rooms" className="text-gray-700 hover:bg-blue-50 hover:text-blue-700 font-medium px-3 py-2 rounded transition-colors" onClick={handleMenuClose}>{t('home.navbar.payment')}</Link>
          <Link to="/booking" className="text-gray-700 hover:bg-blue-50 hover:text-blue-700 font-medium px-3 py-2 rounded transition-colors" onClick={handleMenuClose}>{t('home.navbar.booking')}</Link>
          <Link to="/notice" className="text-gray-700 hover:bg-blue-50 hover:text-blue-700 font-medium px-3 py-2 rounded transition-colors" onClick={handleMenuClose}>{t('home.navbar.notice')}</Link>
          {isAdmin ? (
            <Link to="/admin" className="text-gray-700 hover:bg-blue-50 hover:text-blue-700 font-medium px-3 py-2 rounded transition-colors" onClick={handleMenuClose}>{t('home.navbar.adminDashboard')}</Link>
          ) : (
            <Link to="/admin/login" className="text-gray-700 hover:bg-blue-50 hover:text-blue-700 font-medium px-3 py-2 rounded transition-colors" onClick={handleMenuClose}>{t('home.navbar.adminLogin')}</Link>
          )}
        </div>
        {/* 移动端菜单抽屉 */}
        {menuOpen && (
          <div className="fixed inset-0 bg-black bg-opacity-30 z-20 md:hidden" onClick={handleMenuClose} />
        )}
        <div
          className={`fixed top-0 right-0 h-full w-2/3 max-w-xs bg-white shadow-lg z-30 transform transition-transform duration-200 md:hidden ${menuOpen ? 'translate-x-0' : 'translate-x-full'}`}
        >
          <div className="flex flex-col pt-20 px-6 space-y-6">
            <Link to="/rooms" className="text-gray-700 hover:bg-blue-50 hover:text-blue-700 font-medium px-3 py-2 rounded transition-colors" onClick={handleMenuClose}>{t('home.navbar.payment')}</Link>
            <Link to="/booking" className="text-gray-700 hover:bg-blue-50 hover:text-blue-700 font-medium px-3 py-2 rounded transition-colors" onClick={handleMenuClose}>{t('home.navbar.booking')}</Link>
            <Link to="/notice" className="text-gray-700 hover:bg-blue-50 hover:text-blue-700 font-medium px-3 py-2 rounded transition-colors" onClick={handleMenuClose}>{t('home.navbar.notice')}</Link>
            {isAdmin ? (
              <Link to="/admin" className="text-gray-700 hover:bg-blue-50 hover:text-blue-700 font-medium px-3 py-2 rounded transition-colors" onClick={handleMenuClose}>{t('home.navbar.adminDashboard')}</Link>
            ) : (
              <Link to="/admin/login" className="text-gray-700 hover:bg-blue-50 hover:text-blue-700 font-medium px-3 py-2 rounded transition-colors" onClick={handleMenuClose}>{t('home.navbar.adminLogin')}</Link>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default NavBar; 
